import { render, staticRenderFns } from "./organization-settings.vue?vue&type=template&id=275b31b2&scoped=true&"
import script from "./organization-settings.vue?vue&type=script&lang=js&"
export * from "./organization-settings.vue?vue&type=script&lang=js&"
import style0 from "./organization-settings.vue?vue&type=style&index=0&id=275b31b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b31b2",
  null
  
)

export default component.exports